export const accentColor = "#ff2e35";
